(() => {
  const SELECTED = 'is-selected';

  const closeHeaderMenus = (restoreFocus = false) => {
    document.querySelectorAll('[data-gb-header-menu-toggle][aria-expanded="true"]').forEach((toggle) => {
      const menuId = toggle.getAttribute('aria-controls');
      const menu = menuId ? document.getElementById(menuId) : null;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Menu openen');
      if (menu) menu.hidden = true;
      if (restoreFocus) toggle.focus();
    });
  };

  const updateGallery = (gallery, trigger) => {
    const mediaId = trigger.dataset.gbMediaTarget;
    const panels = gallery.querySelectorAll('[data-gb-media-panel]');
    const triggers = gallery.querySelectorAll('[data-gb-media-target]');

    panels.forEach((panel) => {
      const active = panel.dataset.gbMediaPanel === mediaId;
      panel.hidden = !active;
      panel.classList.toggle(SELECTED, active);
    });

    triggers.forEach((item) => {
      const active = item === trigger;
      item.classList.toggle(SELECTED, active);
      item.setAttribute('aria-current', active ? 'true' : 'false');
    });
  };

  document.addEventListener('click', (event) => {
    const headerMenuToggle = event.target.closest('[data-gb-header-menu-toggle]');
    if (headerMenuToggle) {
      const menuId = headerMenuToggle.getAttribute('aria-controls');
      const menu = menuId ? document.getElementById(menuId) : null;
      if (!menu) return;

      const willOpen = headerMenuToggle.getAttribute('aria-expanded') !== 'true';
      closeHeaderMenus();
      headerMenuToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      headerMenuToggle.setAttribute('aria-label', willOpen ? 'Menu sluiten' : 'Menu openen');
      menu.hidden = !willOpen;
      return;
    }

    if (!event.target.closest('[data-gb-header-menu]')) closeHeaderMenus();

    const galleryTrigger = event.target.closest('[data-gb-media-target]');
    if (galleryTrigger) {
      const gallery = galleryTrigger.closest('[data-gb-gallery]');
      if (gallery) updateGallery(gallery, galleryTrigger);
      return;
    }

    const videoScroll = event.target.closest('[data-gb-video-scroll]');
    if (videoScroll) {
      const trackId = videoScroll.getAttribute('aria-controls');
      const track = trackId ? document.getElementById(trackId) : null;
      const firstCard = track?.querySelector('.gb-video-card');
      if (!track || !firstCard) return;

      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      const direction = Number(videoScroll.dataset.gbVideoScroll) || 1;
      track.scrollBy({
        left: direction * (firstCard.getBoundingClientRect().width + gap),
        behavior: 'smooth',
      });
      return;
    }

    const modalTrigger = event.target.closest('[data-gb-modal-open]');
    if (modalTrigger) {
      const modal = document.getElementById(modalTrigger.dataset.gbModalOpen);
      if (modal && typeof modal.showModal === 'function') {
        modal.showModal();
      }
      return;
    }

    const modalClose = event.target.closest('[data-gb-modal-close]');
    if (modalClose) {
      modalClose.closest('dialog')?.close();
      return;
    }

    const filter = event.target.closest('[data-gb-filter]');
    if (filter) {
      const section = filter.closest('[data-gb-filter-root]');
      if (!section) return;
      const value = filter.dataset.gbFilter;

      section.querySelectorAll('[data-gb-filter]').forEach((button) => {
        const active = button === filter;
        button.classList.toggle(SELECTED, active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      let visibleItems = 0;
      section.querySelectorAll('[data-gb-filter-item]').forEach((item) => {
        const itemTags = (item.dataset.gbFilterItem || '').split(/\s+/);
        const visible = value === 'all' || itemTags.includes(value);
        item.hidden = !visible;
        if (visible) visibleItems += 1;
      });

      section.querySelectorAll('[data-gb-filter-placeholder]').forEach((placeholder) => {
        const visible = value !== 'all'
          && visibleItems === 0
          && placeholder.dataset.gbFilterPlaceholder === value;
        placeholder.hidden = !visible;
      });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeHeaderMenus(true);
      return;
    }

    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    const current = event.target.closest('[data-gb-media-target]');
    if (!current) return;

    const gallery = current.closest('[data-gb-gallery]');
    const triggers = Array.from(gallery?.querySelectorAll('[data-gb-media-target]') || []);
    const index = triggers.indexOf(current);
    const nextIndex = event.key === 'ArrowRight'
      ? (index + 1) % triggers.length
      : (index - 1 + triggers.length) % triggers.length;

    triggers[nextIndex]?.focus();
    updateGallery(gallery, triggers[nextIndex]);
  });

  document.querySelectorAll('[data-gb-modal]').forEach((modal) => {
    modal.addEventListener('click', (event) => {
      if (event.target === modal) modal.close();
    });

    modal.addEventListener('close', () => {
      modal.querySelectorAll('video').forEach((video) => video.pause());
    });
  });
})();
